const ZoneObj = {
  id: undefined,
  code: '',
  name: '',
};

export default ZoneObj;